module.exports = __webpack_public_path__ + "img/clients.92e50e3b.png";